var features = require('lightning-common/lib/configuration/features.json');
var FeatureManager = require('./featureManager');

var buildFeatureManager = function (
    libraryConfigurations,
    tenant,
    allFeatures,
    apiFeatures
) {
    if (!!apiFeatures) {
        features = apiFeatures;
    }
    return new FeatureManager(
        features,
        libraryConfigurations,
        tenant,
        allFeatures
    );
};

module.exports = buildFeatureManager;
